export default __webpack_public_path__ + "static/event-3-74d09032d74e8b9656f2468ec4542ff8.jpg";